import React from 'react'
import {useNavigate} from "react-router"
import style from './homePage.module.css'

import DetatilCard from '../../components/common/DetailCard';
//import SimplaPortefolio from '../../components/common/simplaPortefolio';
import CaroussellCard from '../../components/common/caroussel/CarousselCard'
import kakemon from '../../assets/home/fKakemono.png'

const HomePage = () => {

    const navigate = useNavigate()
    return (
        <div className={style.mainLogin}>

            <div className={style.container}>
                <div className={style.containerHead}>
                    <h2>La gestion comptable et financière ne peut plus se limiter à la conformité :
                        elle doit devenir un véritable levier stratégique.
                    </h2>
                    <p>
                        <span
                            style={{
                            fontFamily: "MozAppearance",
                            fontSize: "70",
                            fontWeight: "bold"
                        }}>GET CONSEIL </span>
                        structure son activité autour de la Préparation, l’Accompagnement-Conseils, la
                        Surveillance-Gestion et le Management Études & Planification, de la préparation le
                        plus en amont possible au suivi, exploitation et développement</p>
                    <div className={style.moreINfo}>
                        <div
                            className={style.info}
                            onClick={() => {
                            navigate("/about")
                        }}>Plus d'info</div>
                        <div
                            className={style.info}
                            onClick={() => {
                            navigate("/contact")
                        }}>Nous écrire</div>
                    </div>
                </div>
            </div>
            <div className={style.mainBody}>
                <DetatilCard homeImage={kakemon}/>
            </div>

            <CaroussellCard/> {/**Footer env */}
            <div
                className={style.signature}
                style={{
                color: "inear-gradient(to bottom, #001a33, #003d82);"
            }}>
                .
            </div>
        </div>
    )
}

export default HomePage
